import config from "../config/config.json";
import {
  handleResponse,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";
import { headers } from "../APIHelpers/Headers";
import axios from "axios";
export const studyDocumentServices = {
  addStudyDocument,
  getStudyDocument,
  deleteStudyDocument,
};

async function addStudyDocument(formData) {
  const response = await axios.post(
    `${config.API_URL_USER_ONBOARDING}addStudyDocument`,
    formData
  );
  const data = response?.data;
  handleResponse(data);
  return data;
}

 //get study document data
 async function getStudyDocument(studyID, mode) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyDocument/${studyID}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

    //delete study data
async function deleteStudyDocument(studyId, id) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyDocument/${studyId}/${id}`,
    headersWithAuthWithoutBody("DELETE", headers)
  );
  const data = await response.json();
  await handleResponse(data);
  return data;
}








